import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from '@mui/material';
import React from 'react'

export default function ConfirmDialog({openStatus, setOpenStatus, handleToggleStatus, item, message}) {
    return (
        <>
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenStatus(false)} open={openStatus}>
            <DialogTitle id='dialog-title'>
                    {!item.isActive && 'Change status of product to active ? '}
                    {item.isActive && `Change status of product ${item.title} to inactive ?`}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{color: "red"}}>
                        {!item.isActive && 'The product will appear in the shop'}
                        {item.isActive && 'The product will disappear from the shop'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => setOpenStatus(false)}
                        variant="contained"
                        >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleToggleStatus(item)}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}